import { get } from '@/services/http';

export class ComparisonDateModel {
  public name: string;
  public code: string;

  constructor(data: any = {}) {
    this.name = data.name;
    this.code = data.code;
  }

  public mapData(data: any = {}) {
    this.name = data.name;
    this.code = data.code;
  }
}
